module.exports = __webpack_public_path__ + "img/christmas-dark-small.3a4ca1aa.svg";